import { poa, will } from '@/mixins/apollo';

export default {
  name: 'MixinsPoaProgress',
  mixins: [poa, will],
  data() {
    return {
      Financial: {
        has_attorney: undefined,
        has_limitations: undefined,
        limitations: undefined,
      },
      Medical: {
        has_attorney: undefined,
        has_preferences: undefined,
        preferences: undefined,
      },
    };
  },
  computed: {
    isPoaApproved() {
      return ['AWAITING_APPROVAL', 'APPROVED'].includes(this.poaStatus);
    },
    hasStartedAboutYourself() {
      return (
        !!this.willMeta.name_first ||
        !!this.willMeta.name_last ||
        !!this.willMeta.address_suburb ||
        !!this.willMeta.address_street ||
        !!this.willMeta.address_state ||
        !!this.willMeta.address_postcode ||
        !!this.willMeta.date_of_birth ||
        !!this.willMeta.phone_number
      );
    },
    hasCompletedAboutYourself() {
      return (
        !!this.willMeta.name_first &&
        !!this.willMeta.name_last &&
        !!this.willMeta.address_suburb &&
        !!this.willMeta.address_street &&
        !!this.willMeta.address_state &&
        !!this.willMeta.address_postcode &&
        !!this.willMeta.date_of_birth
      );
    },
    hasStartedMedical() {
      return this.Medical.has_attorney !== undefined;
    },
    hasCompletedMedical() {
      return (
        this.hasStartedMedical &&
        (this.Medical.has_attorney === false ||
          this.Medical.has_preferences === false ||
          (this.Medical.has_preferences === true &&
            this.Medical.preferences !== undefined))
      );
    },
    hasStartedFinancial() {
      return this.Financial.has_attorney !== undefined;
    },
    hasCompletedFinancial() {
      return (
        this.hasStartedFinancial &&
        (this.Financial.has_attorney === false ||
          this.Financial.has_limitations === false ||
          (this.Financial.has_limitations === true &&
            this.Financial.limitations !== undefined))
      );
    },
    progress() {
      return {
        'About Yourself': (() => {
          return (
            (this.hasStartedAboutYourself + this.hasCompletedAboutYourself) / 2
          );
        })(),
        Financial: (() => {
          return (this.hasStartedFinancial + this.hasCompletedFinancial) / 2;
        })(),
        Medical: (() => {
          return (this.hasStartedMedical + this.hasCompletedMedical) / 2;
        })(),
      };
    },
    poaProgressAsPercentage() {
      if (!this.poaStatus) {
        return 0;
      }
      return Math.round(
        ((!!this.poaStatus +
          this.progress['About Yourself'] +
          this.progress.Financial +
          this.progress.Medical +
          this.isPoaApproved) /
          5) *
          100
      );
    },
  },
};
